import { render, staticRenderFns } from "./WithdrawPix.vue?vue&type=template&id=1b617a0b"
import script from "./WithdrawPix.vue?vue&type=script&lang=js"
export * from "./WithdrawPix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports